import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface SseState {
  gameId: string | null;
  connected: boolean;
  events: Record<string, any>;
}

const initialState: SseState = {
  gameId: null,
  connected: false,
  events: {},
};

const sseSlice = createSlice({
  name: 'sse',
  initialState,
  reducers: {
    sseConnected(state, action: PayloadAction<string>) {
      state.gameId = action.payload;
      state.connected = true;
      state.events = {};
    },
    sseDisconnected(state) {
      state.connected = false;
      state.gameId = null;
      state.events = {};
    },
    sseEventReceived(state, action: PayloadAction<{ event: string; data: any }>) {
      state.events[action.payload.event] = action.payload.data;
    },
  },
});

export const { sseConnected, sseDisconnected, sseEventReceived } = sseSlice.actions;
export default sseSlice.reducer;
